import useGameVideoListData from './useGameVideoListData';

export type { ReturnType } from './types';

export default useGameVideoListData;
